<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(evento.id != null ? 'Evento #' + evento.id : 'Nuovo evento')">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio2 && showdettaglio3 && (showdettaglio1 || this.$route.params.id == null)">
                         <b-row class="my-1">
                                    <b-col sm="3"><label for="titolo">Titolo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.titolo" id="titolo" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="descrizione">Descrizione:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="descrizione" v-model="evento.descrizione" :rows="2"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="(evento.voto > 0)">
                                    <b-col sm="3"><label for="voto">Voto medio:</label></b-col>
                                    <b-col sm="9">
                                        <star-rating id="voto" v-model="evento.voto" read-only :increment="0.01" :star-size="25" :show-rating="true"></star-rating>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="evento.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="sitoweb">Sito web:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.sitoweb" id="sitoweb" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
<!--                                 <b-row class="my-1">
                                    <b-col sm="3"><label for="facebook">Facebook:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.facebook" id="facebook" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="coordinate">Coordinate:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.coordinate" id="coordinate" type="text"></b-form-input>
                                    </b-col>
                                </b-row> -->
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="telefono">Telefono:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.telefono" id="telefono" type="text"></b-form-input>
                                    </b-col>
                                </b-row>
 <!--                                <b-row class="my-1">
                                    <b-col sm="3"><label for="gruppowa">Link gruppo WhatsApp:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.gruppowa" id="gruppowa" type="text"></b-form-input>
                                    </b-col>
                                </b-row> -->
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="email">Email:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.email" id="email" type="email"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.datainizio" id="datainizio" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.datafine" id="datafine" type="date"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1" v-show="evento.tipo == 'G'">
                                    <b-col sm="3"><label for="orainizio">Ora inizio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.orainizio" id="orainizio" type="time"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="evento.tipo == 'G'">
                                    <b-col sm="3"><label for="orafine">Ora fine:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.orafine" id="orafine" type="time"></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="categoria">Categoria:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="evento.id_categoria" :options="options_categorie" id="categoria">
                                            <template slot="first">
                                                      <!-- this slot appears above the options from 'options' prop -->
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="giorniprima">Visibilità giorni prima:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.giorniprima" id="giorniprima" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="visibilità">Visibilità:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="evento.visibilita" :options="options_visibilità" id="visibilità">
                                            <template slot="first">
                                                      <!-- this slot appears above the options from 'options' prop -->
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <!-- <b-row class="my-1">
                                    <b-col sm="3"><label for="prenotabilità">Prenotabilità:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="evento.prenotabilita" :options="options_prenotabilità" id="prenotabilità">
                                            <template slot="first">
                                     
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>                                 -->
                                <b-row v-show="evento.tipo == 'O'" class="my-1">
                                    <b-col sm="3"><label for="domandasondaggio">Domanda sondaggio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="domandasondaggio" v-model="evento.domandasondaggio" :rows="2"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="tipo">Tipo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="evento.tipo" :options="options_tipi" id="tipo">
                                            <template slot="first">
                                                          <!-- this slot appears above the options from 'options' prop -->
                                                          <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="prodotti">Presenza prodotti:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input :value="(evento.prodotti ? 'Sì' : 'No')" id="prodotti" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>


                                <b-row v-show="getShowDisponibilità()" class="my-1">
                                    <b-col sm="3"><label for="postimaxsoci">Posti max per soci:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.postimaxsoci" id="postimaxsoci" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row v-show="getShowDisponibilità()" class="my-1">
                                    <b-col sm="3"><label for="postimax">Posti max per non soci:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.postimax" id="postimax" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row v-show="getShowDisponibilità()" class="my-1">
                                    <b-col sm="3"><label for="postioverbooking">Posti max overbooking:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.postioverbooking" id="postioverbooking" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row v-show="getShowDisponibilità() || getShowSorteggio()" class="my-1">
                                    <b-col sm="3" v-show="getShowDisponibilità() || getShowSorteggio()">
                                        <label for="posti">Posti totali:</label>
                                    </b-col>
<!--                                     <b-col sm="3" v-show="getShowSorteggio()">
                                        <label for="posti">Pezzi totali:</label>
                                    </b-col> -->
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.posti" id="posti" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row v-show="getShowDisponibilità() || getShowSorteggio()" class="my-1">
                                    <b-col sm="3">
                                        <label for="postimin">Numero partecipanti minimo:</label>
                                    </b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.postimin" id="postimin" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row v-show="getShowSorteggio()" class="my-1">
                                    <b-col sm="3">
                                        <label for="numvincitori">Numero vincitori sorteggio:</label>
                                    </b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.numvincitori" id="numvincitori" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row v-show="getShowDisponibilità() || getShowSorteggio()" class="my-1">
                                    <b-col sm="3"><label for="occupati">Partecipanti:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input disabled v-model="evento.occupati" id="occupati" type="number"></b-form-input>
                                    </b-col>
                                </b-row>
<!--                                 <b-row v-show="getShowQuestionario()" class="my-1">
                                    <b-col sm="3"><label for="questionario">Questionario:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="evento.id_questionariodomande" :options="options_quest" id="questionario">
                                            <template slot="first">
                                                          <option :value="null">-- Nessun questionario --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row> -->

                                <!-- pagamenti -->

                                <b-row v-show="getShowPagamento()" class="my-1">
                                    <b-col sm="3"><label for="tipopagamento">Pagamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="evento.tipopagamento" :options="options_tipipagamento" id="tipopagamento">
                                        
                                        </b-form-select>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importoacconto">Importo acconto:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="evento.importoacconto" id="importoacconto" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <b-row v-show="getShowImportiPagamento()" class="my-1">
                                    <b-col sm="3"><label for="importosaldo">Importo saldo:</label></b-col>
                                    <b-col sm="9">
                                        <b-input-group prepend="€">
                                            <b-form-input v-model="evento.importosaldo" id="importosaldo" type="number"></b-form-input>
                                        </b-input-group>
                                    </b-col>
                                </b-row>

                                <!-------------->    

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datanotifica">Data invio notifica:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.datanotifica" id="datanotifica" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="flagnotifica">Notifica inviata:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="flagNotifica" id="flagnotifica" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>

                                <b-row class="my-1">
                                    <b-col sm="3"><label for="id_api">ID Evento API:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.id_api" id="id_api" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>

                                <!--------------> 
                                
                                <b-row class="my-1" v-show="getShowPagamento()">
                                    <b-col sm="3"><label for="datanotificapagamento">Data invio notifica pagamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="evento.datanotificapagamento" id="datanotificapagamento" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="getShowPagamento()">
                                    <b-col sm="3"><label for="testonotificapagamento">Testo notifica pagamento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea v-model="evento.testonotificapagamento" id="testonotificapagamento" type="text" :rows="2"></b-form-textarea>                                    
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="getShowPagamento()">
                                    <b-col sm="3"><label for="flagnotificapagamento">Notifica pagamento inviata:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="flagNotifica" id="flagnotificapagamento" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>

                                

                                <b-row class="my-3">
<!--                                     <b-col sm="6" offset-sm="3" v-if="evento.id != null && evento.tipo != 'D' && evento.tipo != 'R'">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="voti()">
                                            Voti
                                        </b-button>
                                    </b-col>
                                    <b-col sm="3" offset-sm="3" v-if="evento.id != null && (evento.tipo == 'D' || evento.tipo == 'R')">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="voti()">
                                            Voti
                                        </b-button>
                                    </b-col>
                                    <b-col sm="3" v-if="evento.id != null && (evento.tipo == 'D' || evento.tipo == 'R')">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="partecipa()">
                                            Partecipanti
                                        </b-button>
                                    </b-col> -->
                                    <b-col offset-sm="3" sm="9" v-show="evento.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="allegatiImmagini()">
                                            Allegati e immagini
                                        </b-button>
                                    </b-col>                                    
                                </b-row>   
                                <b-row class="my-3" v-show="getShowPagamento() && evento.id != null && (evento.tipo == 'G' || evento.tipo == 'D' || evento.tipo == 'S' || evento.tipo == 'R')">
                                    <b-col sm="3" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="pagamenti()">
                                            Pagamenti
                                        </b-button>
                                    </b-col>   
                                    <b-col sm="3" v-show="evento.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="sconti()">
                                            Sconti
                                        </b-button>
                                    </b-col>    
                                    <b-col sm="3" v-show="evento.id != null">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="pushnotification()">
                                            Push notification
                                        </b-button>
                                    </b-col>                                 
                                </b-row>
<!--                                 <b-row class="my-3" v-show="getShowQuestionario() && evento.id != null">
                                    <b-col sm="5" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="questionari()">
                                            Dettaglio questionari
                                        </b-button>
                                    </b-col>
                                    <b-col sm="4">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="riepilogo()">
                                            Riepilogo questionari
                                        </b-button>
                                    </b-col>
                                </b-row>    -->                              
                                <b-row class="my-3" v-show="evento.tipo == 'O' && evento.id != null">
                                    <b-col sm="9" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="opzionisondaggio()">
                                            Gestione opzioni e risultati sondaggio
                                        </b-button>
                                    </b-col>
                                </b-row>                                 
                               
                                <b-row class="my-3" v-show="getShowSorteggio() && evento.id != null">
                                    <b-col sm="9" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click.stop="inviopushsorteggiovincitori()">
                                            
                                            <span> Invio automatico push vincitori </span>
                                            <b-spinner small v-show="showProgressinviopush"></b-spinner>

                                        </b-button>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1" v-show="evento.id != null && evento.tipo == 'E' && evento.prodotti">
                                    <!-- prenotazione prodotti -->
                                    <b-col sm="9" offset-sm="3">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="prenotazioniProdotti()">
                                            Prenotazioni prodotti
                                        </b-button>
                                    </b-col>
                                
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="9" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="evento.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>
                                        </b-button>
                                    </b-col>
<!--                                     <b-col sm="4" v-show="evento.id != null && (evento.tipo == 'S' || evento.tipo == 'G')">
                                        <b-button block size="md" variant="outline-secondary" v-on:click="prenotazioni()">
                                            Prenotazioni
                                        </b-button>
                                    </b-col> -->
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="(esitoinviopush || '') != ''" variant="success">
                        <div v-html="esitoinviopush"></div>
                    </b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>
import moment from 'moment'

import {
    NAMESPACE,
} from '../config.js'

import {
    ctrlVismenu,
    ctrlViscategoria    
} from '../util.js'

import {
    Categoria,
    Visibilità,
    Prenotabilità,
    Evento,
    TipoPagamento
} from '../classes.js'



export default {
    name: 'appdettaglio',
    data: function () {
        return {
                        
            namespace: NAMESPACE,
            evento: {
                id: this.$route.params.id || null,
                id_categoria: null,
                id_questionariodomande: null,
                visibilita: null,
                //prenotabilita: null,
                prenotabilita: 'N',
                titolo: '',
                descrizione: '',
                domandasondaggio: '',
                note: '',
                sitoweb: '',
                facebook: '',
                coordinate: '',
                telefono: '',
                email: '',
                datainizio: '',
                datafine: '',
                orainizio: '',
                orafine: '',
                tipo: 'E',
                posti: 0,
                giorniprima: 365,
                postimax: 1,
                postimaxsoci: 1,
                postioverbooking: 0,
                postimin: 0,
                occupati: 0,
                datanotifica: '',
                flagnotifica: 'N',
                voto: 0,
                tipopagamento: 'N',
                importoacconto: 0,
                importosaldo: 0, 
                datanotificapagamento: '',
                testonotificapagamento: '',
                flagnotificapagamento: 'N', 
                gruppowa: '',
                numvincitori: 1,
                flagrimlibrifigli: 'S',
                numorerettificarimlibri: 0,
                flagazimodrimlibri: 'N',
                msgdocricrimlibri: '',
                msgcondrimlibri: '',
                prodotti: null,  
                id_api: null,              
            },
            parametri: null,            
            options_flagrimlibrifigli: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],            
            options_flagazimodrimlibri: [{
                value: 'N',
                text: 'No'
            }, {
                value: 'S',
                text: 'Sì'
            }],
            options_categorie: [],
            options_tipi: [],
            options_tipipagamento: [],
            options_visibilità: [],
            options_prenotabilità: [],
            options_quest: [],
            flagTipo: '',
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio2: false,
            showdettaglio3: false,
            dismissSecs: 5,
            dismissCountDown: 0,     
            esitoinviopush: '',
            showProgressinviopush: false,
        };
    },
    computed: {

        flagNotifica: {
            // getter
            get: function () {
                return this.getFlagNotifica();
            }
        },
    },    
    watch: {
        'evento.tipo': function(val, oldVal) {            
            if(val == 'R' && oldVal != null && this.evento.numvincitori == 0){
                this.evento.numvincitori = 3;
            }
        },
        'evento.numvincitori': function(val, oldVal) {            
            if(this.evento.tipo == 'R' && oldVal == 0 && this.evento.id == null){ //sorteggio in inserimento
                this.evento.numvincitori = 3;
            }
        }

    },
    methods: {
        getFlagNotifica() {

            return (this.evento.flagnotifica == 'N' ? 'No' : 'Sì');
        },
        getShowDisponibilità() {

            return (this.evento.tipo == 'D'); //disponibilità
        },
        getShowSorteggio() {

            return (this.evento.tipo == 'R'); //sorteggio
        },
        getShowQuestionario() {

            return (this.parametri.flgquestionari == 'S' && this.evento.tipo != 'O');
        },
        getShowPagamento() {

            return (this.parametri.flgpagamenti == 'S' && this.evento.tipo != 'O');
        },
        getShowImportiPagamento() {

            return (this.parametri.flgpagamenti == 'S' && this.evento.tipopagamento == 'A' && this.evento.tipo != 'O');
        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },

  
        opzionisondaggio() {
            this.$router.push({
                path: `/app/sondaggioopzioni/id/${this.evento.id}/tipo/${this.flagTipo}`
            });
        },
        allegatiImmagini() {

            this.$router.push({
                path: `/app/allegati/id/${this.evento.id}/tipo/${this.flagTipo}`
            });

        },
        questionari() {

            this.$router.push({
                path: `/app/risposte/id_scheda/${this.evento.id}`
            });

        },
        riepilogo() {

            let titoloAux = encodeURIComponent(this.evento.titolo)
            this.$router.push({
                path: `/app/analisirisultati/id_scheda/${this.evento.id}/tipo/${this.flagTipo}/titolo/${titoloAux}`
            });

        },
        prenotazioni() {

            this.$router.push({
                path: `/app/prenotazioni/id/${this.evento.id}/tipo/${this.flagTipo}`
            });

        },
        prenotazioniProdotti() {

            this.$router.push({
                path: `/app/prenotazionipestorico/id_evento/${this.evento.id}`
            });

        },
        partecipa() {

            this.$router.push({
                path: `/app/partecipa/id/${this.evento.id}/tipo/${this.flagTipo}/tipoevento/${this.evento.tipo}`
            });

        },
        voti() {

            this.$router.push({
                path: `/app/voti/id/${this.evento.id}/tipo/${this.flagTipo}`
            });

        },
        pagamenti() {

            this.$router.push({
                path: `/app/pagamenti/id_evento/${this.evento.id}`
            });

        },
        sconti() {

            this.$router.push({
                path: `/app/sconti/id_scheda/${this.evento.id}/tipo/${this.flagTipo}`
            });

        },
        pushnotification() {
            let titoloAux = encodeURIComponent(this.evento.titolo)
            this.$router.push({
                path: `/app/push/id_scheda/${this.evento.id}/tipo/${this.flagTipo}/titolo/${titoloAux}`
            });

        },
        inviopushsorteggiovincitori() {

            this.esitoinviopush = '';
            this.showProgressinviopush = true;
            
            var token = localStorage.getItem('token');
            this.axios.post(NAMESPACE + 'rest/sendpush/evento/sorteggio/id_evento/' + this.evento.id, '', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {
                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            res = res.replace(/\n/g, '<br>');
                            this.esitoinviopush = res;                            
                            this.showProgressinviopush = false; 

                        } else {
                            throw new Error(response.data.message);
                        }
                    } catch (e) {
                        this.showerror = true;                           
                        this.showProgressinviopush = false;
                        this.error = "Errore: " + e.message; 
                    }
                })
                .catch(e => {
                    this.showerror = true;                            
                    this.showProgressinviopush = false;
                    this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        insert() {

                this.esitoinviopush = '';

                var appdettaglio = this;

                var regexOra = new RegExp("^$|^(([01][0-9])|(2[0-3])):[0-5][0-9]$");

                if (this.evento.titolo == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo titolo vuoto!";

                } else if (this.evento.descrizione == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo descrizione vuoto!";

                } else if (this.evento.datainizio == "" || this.evento.datainizio == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data inizio vuoto!";

                } else if (this.evento.datafine == "" || this.evento.datafine == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo data fine vuoto!";

                } else if (this.evento.tipo == 'G' && this.evento.orainizio == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora inizio vuoto!";

                } else if (this.evento.tipo == 'G' && this.evento.orafine == "") {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora fine vuoto!";

                } else if (this.evento.tipoevento == 'G' && !regexOra.test(this.evento.orainizio)) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora inizio con formato diverso da HH:mm!";

                } else if (this.evento.tipoevento == 'G' && !regexOra.test(this.evento.orafine)) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo ora fine con formato diverso da HH:mm!";

                } else if (this.evento.datafine < this.evento.datainizio) { //sono stringhe yyyy-mm-dd
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Data inizio maggiore di data fine!";

                } else if (this.evento.tipo == 'G' && this.evento.orafine <= this.evento.orainizio) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Ora inizio maggiore o uguale di ora fine!";

                } else if (this.evento.id_categoria == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Categoria non selezionata!";

                } else if ((this.evento.visibilita || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità non selezionata!";

                } else if ((this.evento.prenotabilita || '') == '') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Prenotabilità non selezionata!";

                } else if (this.evento.tipo == null) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Tipo non selezionato!";

                } else if (this.evento.tipo == 'D' && this.evento.posti < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Posti totali < 0!";

                } else if (this.evento.tipo == 'D' && this.evento.postimax < 1) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Posti max per non soci < 1!";
                    
                } else if (this.evento.tipo == 'D' && this.evento.postioverbooking < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Posti overbooking < 0!";

                } else if (this.evento.tipo == 'D' && this.evento.postimaxsoci < 1) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Posti max per soci < 1!";

                } else if (this.evento.giorniprima < 0) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Visibilità giorni prima < 0!";

                } else if (this.evento.importoacconto < 0 && this.getShowImportiPagamento()) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo acconto < 0!";

                } else if (this.evento.importosaldo < 0 && this.getShowImportiPagamento()) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo saldo < 0!";

                } else if (this.evento.importosaldo == 0 && this.evento.importoacconto == 0 && this.getShowImportiPagamento()) {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Importo saldo e importo acconto entrambi uguali a 0!";

                } else if (this.evento.domandasondaggio == "" && this.evento.tipo == 'O') {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo domanda sondaggio vuoto!";

                } else if (this.evento.numvincitori < 1 && this.evento.tipo == 'R') { //sorteggio
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Campo numero vincitori < 1!";

                } else {

                    var json = JSON.stringify(this.evento);

                    var token = localStorage.getItem('token');
                    this.axios.post(NAMESPACE + 'rest/evento', json, {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': token
                            }
                        })
                        .then(response => {
                            // JSON responses are automatically parsed.
                            try {

                                if (!response.data.error) {

                                    if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                    var res = response.data.message;
                                    if (res.length > 0) {
                                        res[0].datanotifica = (res[0].datanotifica == "0000-00-00 00:00:00" ? "" : moment(res[0].datanotifica, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"));
                                        res[0].datanotificapagamento = (res[0].datanotificapagamento == "0000-00-00 00:00:00" ? "" : moment(res[0].datanotificapagamento, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"));
                                        this.evento = res[0];
                                        this.evento.voto = parseFloat(this.evento.voto);
                                        this.showerror = false;
                                        this.showdettaglio1 = this.showdettaglio2 = this.showdettaglio3 = true; //anche se non dovrebbe servire                                 
                                        this.dismissCountDown = this.dismissSecs;

                                        this.$route.params.id = this.evento.id;

                                        this.$router.replace('/app/dettaglioevento/' + this.evento.id);

                                    } else {
                                        throw new Error("Errore dati non trovati!");
                                    }


                                } else {
                                    throw new Error(response.data.message);
                                }


                            } catch (e) {
                                this.showerror = true;
                                this.error = "Errore: " + e.message;
                            }

                        })
                        .catch(e => {
                            this.showerror = true;
                            this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                        });

                }

            }


    },    
    created: function () {

        

            if(!ctrlVismenu("E")){
                this.$router.replace('/accessdenied');
                return;
            }



            var appdettaglio = this;

            var evento = new Evento();
            var options = [];
            var listaTipi = Object.keys(evento.getListaTipi());
            for (var i = 0; i < listaTipi.length; i++) {            
                options.push({
                    value: listaTipi[i],
                    text: evento.getTipoByFlag(listaTipi[i])
                });                               
            }
            this.options_tipi = options;

            var tp = new TipoPagamento();
            var options2 = [];
            var listaTipiPagamento = Object.keys(tp.getListaTipi());
            for (i = 0; i < listaTipiPagamento.length; i++) {
                options2.push({
                    value: listaTipiPagamento[i],
                    text: tp.getTipoByFlag(listaTipiPagamento[i])
                });
            }
            this.options_tipipagamento = options2;

            var token = localStorage.getItem('token');             
            var id = this.evento.id; //se è la prima volta si prova a prendere da getid 

            if (id != null) {
                               

                this.axios.get(NAMESPACE + 'rest/eventi/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {

                                    if (this.$route.params.duplica == 'true') {
                                        res[0].id = null;
                                        res[0].occupati = 0;
                                        res[0].flagnotifica = 'N';
                                        res[0].voto = 0;
                                        res[0].id_api = null;
                                        res[0].prodotti = null;
                                    }
                                    res[0].datanotifica = (res[0].datanotifica == "0000-00-00 00:00:00" ? "" : moment(res[0].datanotifica, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"));
                                    res[0].datanotificapagamento = (res[0].datanotificapagamento == "0000-00-00 00:00:00" ? "" : moment(res[0].datanotificapagamento, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"));
                                    this.evento = res[0];
                                    this.evento.voto = parseFloat(this.evento.voto);
                                    this.showdettaglio1 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

             //////////////////////////////////////
            const tipoPagina = 'Evento';
            //////////////////////////////////////

            //creo la tendina visibilità
            var visibilità = new Visibilità();
            var options_vis = [];
            for (i = 0; i < Object.keys(visibilità.getListaTipi()).length; i++) {
                options_vis.push({
                    value: Object.keys(visibilità.getListaTipi())[i],
                    text: visibilità.getTipoByFlag(Object.keys(visibilità.getListaTipi())[i])
                });
            }
            this.options_visibilità = options_vis;

            //creo la tendina prenotabilità
            var prenotabilità = new Prenotabilità();
            var options_pre = [];
            for (i = 0; i < Object.keys(prenotabilità.getListaTipi()).length; i++) {
                options_pre.push({
                    value: Object.keys(prenotabilità.getListaTipi())[i],
                    text: prenotabilità.getTipoByFlag(Object.keys(prenotabilità.getListaTipi())[i])
                });
            }
            this.options_prenotabilità = options_pre;

            //recupero il valore del flag del tipo della categoria
            var cat = new Categoria();
            var tipi = cat.getListaTipi();
            var keys = Object.keys(tipi);
            var flagTipo = "";
            for (i = 0; i < keys.length; i++) {
                if (tipi[keys[i]] == tipoPagina) {
                    flagTipo = keys[i];
                }
            }

            this.flagTipo = flagTipo;

            //chiamo il servizio che mi restituisce tutte le categorie di quel tipo
            this.axios.get(NAMESPACE + 'rest/categorie/tipo/' + flagTipo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                var options = [];
                                for (var i = 0; i < res.length; i++) {
                                    options.push({
                                        value: res[i].id,
                                        text: res[i].descrizione
                                    });
                                }

                                this.options_categorie = options;

                                this.options_categorie = this.options_categorie.filter(function (element) {                       
                                    return ctrlViscategoria(element.value);
                                });

                                this.showdettaglio2 = true;

                            } else {
                                throw new Error("Errore categorie non trovate!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            //chiamo il servizio che mi restituisce tutti i questionari attivi
            this.axios.get(NAMESPACE + 'rest/questionaridomande/flagsta/S', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                var options = [];
                                for (var i = 0; i < res.length; i++) {
                                    options.push({
                                        value: res[i].id,
                                        text: res[i].titolo
                                    });
                                }

                                this.options_quest= options;
                                this.showdettaglio2 = true;

                            } else {
                                //commentato perchè non si capisce perchè debba essere un errore
                                //throw new Error("Errore questionari non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

            //PAREMETRI
            this.axios.get(NAMESPACE + 'rest/cral', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            //alert("Ret: " + JSON.stringify(res))
                            if (typeof res == "object") {

                                this.parametri = res;
                                                                
                                //controllo abilitazione eventi giornalieri
                                this.options_tipi = this.options_tipi.filter(function(item) {
                                                        return !(item.value == 'G' && appdettaglio.parametri.flgeventigiornalieri == 'N');
                                                    });
                               
                                this.showdettaglio3 = true;

                            } else {
                                throw new Error("Errore parametri non trovati!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });
            

    },    
    mounted: function() {
        
        
        
    }

}
</script>
